import { Product } from '../static/Product';

const noInsuredAddressStates: string[] = ['PA', 'TX', 'WA'];
const noOwnerAddressStates: string[] = ['PA', 'TX', 'WA'];

export class HIVStateOptions {
  static getOptions(
    insuredState: string,
    ownerState: string,
    havePrimaryPhysician: boolean = false,
    channel,
    productCode: string
  ): string[] {
    const defaultOpts: string[] = havePrimaryPhysician
      ? ['insured_address', 'insured_another_address', 'pp_address', 'pp_another_address']
      : ['insured_address', 'insured_another_address', 'pp_another_address'];

    if (channel !== 'CAS') {
      defaultOpts.push('state_health');
    }

    if (noInsuredAddressStates.indexOf(insuredState) >= 0 || noOwnerAddressStates.indexOf(ownerState) >= 0) {
      defaultOpts.splice(defaultOpts.indexOf('insured_address'), 1);
      defaultOpts.splice(defaultOpts.indexOf('insured_another_address'), 1);
    }

    if (ownerState === 'CA') {
      defaultOpts.push('noneoftheabove');
    }

    if (insuredState === 'MI' || ownerState === 'MI') {
      defaultOpts.push('optout');
    } else if (ownerState === 'NY') {
      defaultOpts.splice(defaultOpts.indexOf('state_health'), 1);
    } else if (ownerState === 'CT' && channel !== 'CAS') {
      defaultOpts.splice(defaultOpts.indexOf('state_health'), 1);
      defaultOpts.push('other_healthcare');
    }
    return defaultOpts;
  }
}
